var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"id":"global_alert_bar","dismissible":"","variant":_vm.$store.state.global_alert.message.type,"show":""}},[_vm._v(_vm._s(_vm.$store.state.global_alert.message.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }